import { Element } from '@zmedia/bm-soccer-ui/components';
import { memo } from 'react';
import { IMatchDetail } from '@zmedia/bm-soccer-ui/interface';
import { Score, Team } from '@zmedia/bm-soccer-ui/modules/match/components';
import styles from './style.module.scss';

export function HeaderMatchScore(props: IMatchDetail) {
    const { home, away } = props;

    if (!(home?.score >= 0 || away?.score >= 0)) {
        return null;
    }

    return (
        <Element className={styles['match-header-scores']}>
            <Team team={home.team} isLink={true} />
            <Element className={styles['scores-info']}>
                <Score item={props} isDetailPage={true} />
            </Element>
            <Team team={away.team} isLink={true} />
        </Element>
    );
}

export default memo(HeaderMatchScore);
